import { render } from "./AddSubject.vue?vue&type=template&id=3be8ace0&ts=true"
import script from "./AddSubject.ts?vue&type=script&lang=ts"
export * from "./AddSubject.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__